window['$']("#register").click(function(){
    window['$']("#collapseRegister").collapse('toggle'); // toggle collapse
});